import * as React from 'react';
import type { SpecRuntimeController } from './runtime-provider.js';

/** The runtime's context on its own, so a page outside the Spec chunk can reach it without loading the runtime. */
export const SpecRuntimeContext = React.createContext<SpecRuntimeController | null>(null);

/** Returns null when Spec is not mounted (production without a Worker URL), or not yet loaded. */
export function useOptionalSpecRuntime(): SpecRuntimeController | null {
  return React.useContext(SpecRuntimeContext);
}
